<template>
    <v-layout row wrap align-center>
        <v-flex xs12 class="title">Ticketauswahl</v-flex>
        <v-flex xs12>
            <template v-for="(ticket, index) in tickets">
                <div class="my-2 py-2">
                    <v-layout fill-height wrap align-center
                              v-if="(ticket.remaining === null || ticket.remaining > 0 ) && (event.remaining === null || event.remaining > 0 )">
                        <v-flex shrink>
                            <div class="subheading">{{ticket.name}}</div>
                            <div class="caption">{{ticket.rendered_price}}<span v-if="organizer.tax_rate>0"> (inkl. MwSt)</span></div>
                        </v-flex>
                        <v-spacer></v-spacer>
                        <v-flex shrink>
                            <s-spinner :disabled="ticketsLoading" v-model="ticket.quantity" @input="setTicketsDelayed"
                                       :ticket-remaining="ticket.remaining"
                                       :selected-tickets-count="selectedTicketsCount"
                                       :event-remaining="event.remaining"></s-spinner>
                        </v-flex>
                    </v-layout>
                    <v-layout fill-height wrap align-center v-else>
                        <v-flex shrink>
                            <div class="subheading">{{ticket.name}}</div>
                            <div class="caption">{{ticket.rendered_price}}<span v-if="organizer.tax_rate>0"> (inkl. MwSt)</span></div>
                            <div class="caption">Nicht mehr verfügbar</div>
                        </v-flex>
                        <v-spacer></v-spacer>
                        <v-flex shrink>
                            <queue-dialog :ticket-id="ticket.id"></queue-dialog>
                        </v-flex>
                    </v-layout>
                </div>
                <v-divider
                    :key="index+'d'"
                ></v-divider>
            </template>
        </v-flex>
        <v-flex xs12>
            <v-layout row wrap>
                <v-flex class="text-xs-right">
                    <button-next @click="nextButtonClick()" :disabled="ticketsLoading"></button-next>
                </v-flex>
            </v-layout>
        </v-flex>
    </v-layout>
</template>

<script>
    import QueueDialog from "./QueueDialog";
    import {mapState} from 'vuex'
    import {mapMutations} from 'vuex'
    import {mapActions} from 'vuex'

    export default {
        name: "TicketSelectionStep",
        components: {QueueDialog},
        data() {
            return {
                displayErrors: false,
                delayedClick: null,
            }
        },
        computed: {
            ...mapState('form', [
                'event',
                'organizer',
                'tickets',
                'ticketsLoading',
            ]),
            ticketsSelected() {
                return this.selectedTicketsCount > 0
            },
            selectedTicketsCount() {
                return _.sumBy(this.tickets, 'quantity')
            },
        },
        methods: {
            ...mapMutations('stepper', [
                'nextStep'
            ]),
            ...mapActions('form', [
                'setError',
                'setTickets',
            ]),
            setTicketsDelayed() {
                if(this.delayedClick) {
                    clearTimeout(this.delayedClick);
                }
                this.delayedClick = setTimeout(()=>{this.setTickets(this.tickets)}, 500);
            },

            nextButtonClick() {
                if (this.ticketsSelected) {
                    this.nextStep();
                } else {
                    this.setError('Bitte wählen Sie mindestens ein Ticket aus.');
                }
            },
        }
    }
</script>

<style scoped>

</style>
